import {
  useClearRefinements,
  useCurrentRefinements,
  useSearchBox,
} from 'react-instantsearch';
import X from '@/assets/icons/X.svg';
import { useSearchData } from '@/contexts/searchContext';
import * as Styled from './SearchHeader.styled';

const getRefinementLabel = (
  attribute: string,
  label: string,
  mapAgeLabel: (code: string) => string,
): string => {
  if (attribute === 'ageRange') {
    return mapAgeLabel(label);
  }

  if (attribute === 'inStock') {
    return 'Show in stock only';
  }

  if (attribute === 'hierarchicalCategories.lvl0') {
    return label.split('>').pop()?.trim() ?? label;
  }

  if (attribute === 'seriesCode') {
    return `Series: ${label}`;
  }

  return label;
};

export const SearchHeader = () => {
  const { ageRanges, showingResultsForLabel } = useSearchData();
  const { query } = useSearchBox();
  const { items, refine: removeRefinement } = useCurrentRefinements();
  const { refine: clearAll, canRefine } = useClearRefinements();

  const mapAgeLabel = (code: string): string => {
    const range = ageRanges.find(r => r.code === code);
    return range?.label ?? code;
  };

  return (
    <Styled.Wrapper>
      <Styled.ResultsFor>
        {query && query.length > 0 ? (
          <>
            {showingResultsForLabel}{' '}
            <Styled.SearchTerm>{query}</Styled.SearchTerm>
          </>
        ) : (
          'Showing results'
        )}
      </Styled.ResultsFor>

      <Styled.RefinementsRow>
        {items.length > 0 ? (
          <>
            <span>Applied:</span>
            {items.flatMap(item =>
              item.refinements.map(refinement => (
                <Styled.FilterTag
                  key={`${item.attribute}-${refinement.label}`}
                  onClick={() => removeRefinement(refinement)}
                  type="button"
                >
                  {getRefinementLabel(item.attribute, refinement.label, mapAgeLabel)}
                  <X />
                </Styled.FilterTag>
              )),
            )}
            {canRefine ? (
              <Styled.ClearAllButton onClick={clearAll} type="button">
                Clear all filters
              </Styled.ClearAllButton>
            ) : null}
          </>
        ) : null}
      </Styled.RefinementsRow>
    </Styled.Wrapper>
  );
};
